import produce from 'immer';
import { ImportListItemResponse, MetaPagination } from '../../../api';
import { baseDataManagementActions } from '../actions';

export interface BaseDataManagementState {
  importHistory: {
    data: ImportListItemResponse[];
    pagination: MetaPagination['page'] | undefined;
    ok: boolean | undefined;
  };
}

export const INITIAL_DATA_MANAGEMENT_STATE: BaseDataManagementState = {
  importHistory: {
    data: [],
    pagination: undefined,
    ok: undefined,
  },
};

export function BaseDataManagementReducer(
  state: BaseDataManagementState = INITIAL_DATA_MANAGEMENT_STATE,
  action: any
): any {
  return produce(state, (draftState) => {
    switch (action.type) {
      // Import history
      case baseDataManagementActions.loadImportHistory.type:
        draftState.importHistory.ok = undefined;
        return;

      case baseDataManagementActions.setImportHistory.type:
        draftState.importHistory.data = action.payload;
        draftState.importHistory.pagination = action.pagination;
        return;

      case baseDataManagementActions.successImportHistory.type:
        draftState.importHistory.ok = true;
        return;

      case baseDataManagementActions.errorImportHistory.type:
        draftState.importHistory.ok = false;
        return;
    }
  });
}
